import { createFileRoute } from '@tanstack/react-router'
import AuthScreen from './-components'

export const Route = createFileRoute('/(auth)/change-password/')({
  component: () => <AuthScreen />
})